import { IconCheckbox, IconChevronRight } from '@tabler/icons-react-native';
import { presentInsuredDetailsAtom } from 'app/atoms';
import { InsuredBadge } from 'app/design/icons/insured-badge';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useSetAtom } from 'jotai';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

const theme = createDSTheme();

function Benefit({ children }: { children: React.ReactNode }) {
  return (
    <Row alignItems="center" gap="spacing.general.x4" paddingHorizontal="spacing.general.x2">
      <IconCheckbox color={theme.colors['icon.primary']} size={24} strokeWidth={ICON_STROKE_WIDTH} />
      <Text color="text.primary" variant="bodyBaseMedium">
        {children}
      </Text>
    </Row>
  );
}

export function PaymentIntro() {
  return (
    <Text color="text.primary" variant="headerSmall">
      <Trans
        components={{ highlight: <Text style={{ color: '#64466C' }} variant="headerSmall" /> }}
        i18nKey="intro"
        ns="payment"
      />
    </Text>
  );
}

export function PaymentBenefits() {
  const { t } = useTranslation(['payment', 'paywall']);
  const presentInsuredDetails = useSetAtom(presentInsuredDetailsAtom);

  return (
    <Column gap="spacing.general.x4">
      <Text color="text.primary" variant="bodyLargeStrong">
        {t('benefitsTitle', { ns: 'payment' })}
      </Text>
      <Benefit>{t('redesign.unlimitedLending', { ns: 'paywall' })}</Benefit>
      <Benefit>{t('redesign.unlimitedBorrowing', { ns: 'paywall' })}</Benefit>
      <Pressable onPress={() => presentInsuredDetails({ insured: true })}>
        <Row
          alignItems="center"
          backgroundColor="surface.secondary"
          borderRadius="radius.md"
          gap="spacing.general.x2"
          padding="spacing.general.x2"
        >
          <InsuredBadge
            checkColor={theme.colors['icon.brand']}
            color={theme.colors['surface.default']}
            height={30}
            width={30}
          />
          <Text color="text.primary" flex={1} variant="bodyBaseMedium">
            {t('redesign.damageCoverage', { ns: 'paywall' })}
          </Text>
          <IconChevronRight color={theme.colors['icon.primary']} size={24} strokeWidth={ICON_STROKE_WIDTH} />
        </Row>
      </Pressable>
    </Column>
  );
}
